import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import { PierGroupFootmarks, BerthFootmarks } from './model';

import { PCSortable } from 'portcall/pcsortable/view';
import { ToggleableMeasurementView } from 'portcall/toggleablemeasurement/view';

export const PierGroupFootmarksView = SuperCritical(({ model: m } : { model : PierGroupFootmarks }) =>
    <div className="piergroupfootmarks">
        <ColumnHeaders />
        <BerthsTable model={m} />
        <TotalGroupLength model={m} />
    </div>
);

const ColumnHeaders = SuperCritical(() =>
    <div className="pgfm-headers">
        <span className="pgfm-col pgfm-berth-name">Berth</span>
        <span className="pgfm-col pgfm-startmark">Starting footmark</span>
        <span className="pgfm-col pgfm-length">Length</span>
    </div>
);

const BerthsTable = SuperCritical(({ model: m } : { model : PierGroupFootmarks }) =>
    <PCSortable
        className="pgfm-berths-in-group"
        onSort={m.OnSortBerths}
        items={m.Berths}
        rowFactory={b =>
            <BerthRow berth={b} key={b.Berth.Id()} />
        }
    />
);

const BerthRow = SuperCritical(({ berth: b } : { berth : BerthFootmarks }) =>
    <li>
        <div>
            <span className="pgfm-col pgfm-berth-name">{b.Berth.Location()?.Name()}</span>
            <span className="pgfm-col pgfm-startmark">
                <ToggleableMeasurementView model={b.StartMark} />
                {' '}
                {b.StartMark.uom()}
            </span>
            <span className="pgfm-col pgfm-length">
                {/* Suppress display of invalid lengths. Instead we'll show an error message
                    on the next input. */}
                {b.LengthIsValid() && <ToggleableMeasurementView model={b.Length} textonly />}
            </span>
        </div>
        {!b.PrevLengthIsValid() &&
            <div className="pgfm-invalid-entry">
                Cannot be less than the prior berth's starting footmark.
            </div>
        }
    </li>
);

const TotalGroupLength = SuperCritical(({ model: m } : { model : PierGroupFootmarks }) =>
    <div className="pgfm-total-group-length">
        <div>
            <span className="pgfm-col pgfm-berth-name">Total group length</span>
            <span className="pgfm-col pgfm-startmark">{/* Empty placeholder cell */}</span>
            <span className="pgfm-col pgfm-length">
                <ToggleableMeasurementView model={m.PierGroupLength} />
                {' '}
                {m.PierGroupLength.uom()}
            </span>
        </div>
        {!m.LastBerthLengthIsValid() &&
            <div className="pgfm-invalid-entry">
                Cannot be less than the sum of the lengths above.
            </div>
        }
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/piergroupfootmarks/view.tsx